import styled, { css } from "styled-components/native";
import { View, Text } from "react-native";
import { space, layout, compose } from "styled-system";
import { Paragraph } from "../typography";
import { Theme } from "../../theming/types";

const styledUtils = compose(space, layout);

export const StyledViewContainer = styled(View)`
  ${styledUtils};
  align-items: center;
`;

export const StyledParagraph = styled(Paragraph)`
  text-align: center;
  color: ${({ theme }: { theme: Theme }) => theme.colors.grey[800]};
`;

export const StyledTextTitle = styled(Text)`
  text-align: center;
  ${({ theme }: { theme: Theme }) => css`
    font-family: ${theme.fonts.bold};
    font-size: ${theme.fontSizes.m};
    color: ${theme.colors.grey[900]};
    margin-top: ${theme.space["space-6"]};
    margin-bottom: ${theme.space["space-3"]};
  `}
`;
